import React from 'react'

const ModalBody = (props) => {
    return (
        <div className="relative px-6 py-1.5 flex-auto overflow-y-auto">
            {props.children}
        </div>
    )
}

export default ModalBody